import { AppRoutes } from "../constants/routes/app-routes";

export function handleForbiddenError(history: any, authData: ForbiddenResponse["data"]) {
  return history.push({
    pathname: AppRoutes.Forbidden,
    search: `?url=${encodeURI(window.location.pathname)}`,
    state: { ...authData },
  });
}
